import styled from "styled-components";
import { maxSize, textLineClamp } from "../../Utils/common";
import { STYLE_TYPE, themeColor } from "../../Utils/magicStrings";

export const ReserveWrapper = styled('div')`
    position: relative;
`;

export const Line = styled('div')`
    position: absolute;
    ${props => maxSize(753, props.styleType, 'left')};
    top: 0;
    height: 100%;
    border-left: 1px solid ${themeColor};
    
`;

export const MainPart = styled('div')`
    position: relative;
    font-size: 0;
    width: min(1440px, 100vw);
    margin: auto;
    ${props => maxSize(96, props.styleType, 'margin-top', 46)};
`;

export const LeftPartWrapper = styled('div')`
    display: inline-block;
    vertical-align: top;
    ${props => maxSize(269, props.styleType, 'margin-left', 106)};
    ${props => maxSize(440, props.styleType, 'width', 106)};
    ${props => {
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
                ${maxSize(45, props.styleType, 'padding-right')};
                border-right: 1px solid #D1BB8B;
            `
        }
    }}
    

`;

export const LeftTitle = styled('div')`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${props => maxSize(24, props.styleType, 'font-size', 18)};
    text-align: center;

`;
export const ReservePictureWrapper = styled('div')`
    margin: auto;
    border-radius: 8px;
    overflow: hidden;
    ${props => maxSize(24, props.styleType, 'margin-top', 24)};
    ${props => maxSize(440, props.styleType, 'width', 343)};
    ${props => maxSize(295, props.styleType, 'height', 230)};
`;
export const BenefitItemWrapper = styled('div')`    
    margin: auto;
    ${props => maxSize(433, props.styleType, 'width', 343)};

`;
export const BenefitItemTitle = styled('div')`
    display: flex;
    align-items: center;
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
    ${props => maxSize(16, props.styleType, 'margin-top', 24)};

    & #dot {
        flex: 0 0 auto;
        display: inline-block;
        border-radius: 50%;
        background-color: ${themeColor};
        ${props => maxSize(14, props.styleType, 'width', 8)};
        ${props => maxSize(14, props.styleType, 'height', 8)};
        ${props => maxSize(13, props.styleType, 'margin-right', 8)};
    }
    & #text {
        flex: 0 0 auto;
        max-width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: inline-block;
    }
`;
export const BenefitItemContent = styled('div')`
    ${props => maxSize(12, props.styleType, 'margin-top', 8)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
    ${props => maxSize(24, props.styleType, 'line-height', 24)};
    ${textLineClamp(2)};
    letter-spacing: 0.06em;
    color: #A38F8F;
`;
export const BenefitWrapper = styled('div')`    
    overflow: scroll;
    &::-webkit-scrollbar { display: none !important; }
    ${props => maxSize(348, props.styleType, 'max-height', 320)};
`;
export const LeftIntroText = styled('div')`
    margin: auto;
    ${props => maxSize(28, props.styleType, 'margin-top', 24)};
    ${props => maxSize(14, props.styleType, 'font-size', 14)};
    ${props => maxSize(440, props.styleType, 'width', 326)};    
`;
export const PlanWrapper = styled('div')`
    overflow: scroll;
    &::-webkit-scrollbar { display: none !important; }
    ${props => maxSize(8, props.styleType, 'padding-top', 8)};
    ${props => maxSize(400, props.styleType, 'max-height', 340)};
`;
export const PlanItemWrapper = styled('div')`
    position: relative;
    background-color: #D1BB8B;
    margin: auto;
    border-radius: 4px;
    ${props => maxSize(8, props.styleType, 'margin-top', 8)};
    ${props => maxSize(430, props.styleType, 'width', 343)};
    ${props => maxSize(120, props.styleType, 'height', 95)};
`;

export const PlanPicture = styled('div')`
    position: absolute;
    ${props => maxSize(154, props.styleType, 'width', 123)};
    ${props => maxSize(88, props.styleType, 'height', 70)};
    ${props => maxSize(16, props.styleType, 'top', 12.7)};
    ${props => maxSize(16, props.styleType, 'left', 12.7)};
    & img{
        width: 100%;
        height: 100%;
    }
`;

export const PlanName = styled('div')`
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    ${props => maxSize(160, props.styleType, 'max-width', 128)};
    ${props => maxSize(16, props.styleType, 'top', 17)};
    ${props => maxSize(189, props.styleType, 'left', 151)};
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
`;

export const PlanPrice = styled('div')`
    position: absolute;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    letter-spacing: 0.06em;
    color: #8F7951;
    ${props => maxSize(160, props.styleType, 'max-width', 128)};
    ${props => maxSize(189, props.styleType, 'left', 151)};
    ${props => maxSize(40, props.styleType, 'top', 34)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
`;

export const PlanButton = styled('div')`
    position: absolute;
    background: #F8F5F1;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.16);
    border-radius: 26px;
    color: black;
    text-align: center;
    ${props => maxSize(43 , props.styleType, 'line-height', 36)};
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
    ${props => maxSize(189, props.styleType, 'left', 151)};
    ${props => maxSize(65, props.styleType, 'top', 52)};
    ${props => maxSize(39, props.styleType, 'height', 31)};
    ${props => maxSize(160, props.styleType, 'width', 128)};
    
`;
export const ReserveTeleWrapper = styled('div')`
    margin: auto;
    ${props => maxSize(24, props.styleType, 'margin-top', 17)};
    ${props => maxSize(18, props.styleType, 'font-size', props.isDetail ? 12 : 14)};
    ${props => maxSize(430, props.styleType, 'width', 343)};
    ${props => {
        if(!props.isDetail) return '';
        if(props.styleType !== STYLE_TYPE.MOBILE) {
            return `
            text-align: center;

            `
        } else {
            return `
                width: auto;
            text-align: center;

            `
        }
    }}
`;

export const MemoWrapper = styled('div')`
    color: #A38F8F;
    letter-spacing: 0.06em;
    margin: auto;
    ${props => maxSize(14, props.styleType, 'margin-top', 8)};
    ${props => textLineClamp(props.styleType === STYLE_TYPE.MOBILE ? 2 : 3)};
    ${props => maxSize(430, props.styleType, 'width', 343)};
    ${props => maxSize(24, props.styleType, 'line-height', 24)};
    ${props => maxSize(14, props.styleType, 'font-size', 10)};
`;

export const RightPartWrapper = styled('div')`
    display: inline-block;
    vertical-align: top;
    &::-webkit-scrollbar { display: none !important; }
    ${props => maxSize(45, props.styleType, 'margin-left', 0)};
    ${props => maxSize(372, props.styleType, 'width', 106)};
`;

export const ChoiceWrapper = styled('div')`
    position: relative;
    display: flex;
    align-items: center;
    background: #D1BB8B;
    margin: auto;
    border-radius: 4px;
    ${props => maxSize(372, props.styleType, 'width', 339)};
    ${props => maxSize(77, props.styleType, 'height', 56)};
    ${props => {
        if(props.type === 'room') {
            return maxSize(16, props.styleType, 'margin-top', 8);
        } else if (props.type === 'people') {
            return maxSize(0, props.styleType, 'margin-top', 16);
        } else if (props.type === 'calendar') {
            return maxSize(16, props.styleType, 'margin-top', 8);
        }
    }};
`;

export const ChoiceLogo = styled('div')`
    & img {
        width: 100%;
        height: 100%;
    }
    ${props => {
        if(props.type === 'room') {
            return `
                ${maxSize(19, props.styleType, 'height', 12)};
                ${maxSize(30, props.styleType, 'width', 19)};
            `;
        } else if (props.type === 'people') {
            return `
                ${maxSize(24, props.styleType, 'height', 16)};
                ${maxSize(26, props.styleType, 'width', 18)};
            `;
        } else if (props.type === 'calendar') {
            return `
                ${maxSize(33, props.styleType, 'height', 19)};
                ${maxSize(33, props.styleType, 'width', 19)};
            `;
        }
    }};
    ${props => maxSize(30, props.styleType, 'margin-left', 30)};

`;

export const ChoiceText = styled('div')`
    ${props => maxSize(18, props.styleType, 'font-size', 14)};
    ${props => maxSize(7.2, props.styleType, 'margin-top', 0.1)};

    ${props => {
        if(props.type === 'room') {
            return maxSize(11, props.styleType, 'margin-left', 9);
        } else if (props.type === 'people') {
            return maxSize(13, props.styleType, 'margin-left', 10);
        } else if (props.type === 'calendar') {
            return maxSize(13, props.styleType, 'margin-left', 10);
        }
    }};
    color: ${props => props.color};
    ${props => maxSize(props.type === 'people' ? 13 : 11, props.styleType, 'margin-left', props.type === 'people' ? 10 : 9)};

`;

export const ChoiceArrow = styled('div')`
    position: absolute;
    & img {
        width: 100%;
        height: 100%;
        display: block;
    }
    top: 50%;
    transform: translate(0, -50%);
    ${props => maxSize(317, props.styleType, 'left', 294)};
    ${props => maxSize(12, props.styleType, 'height', 11)};
    ${props => maxSize(23, props.styleType, 'width', 21)};
`;


export const Shadow = styled('div')`
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 99;
    background: rgba(0, 0, 0, 0.67);
`;

export const ChoiceMainWrapper = styled('div')`
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return `
                position: fixed;
                bottom: 0;
                background: #F8F5F1;
                z-index: 100;
                ${maxSize(375, props.styleType, 'width', 375)};
            `
        } else {
            return `
                border: 1px solid #B69A67;
                border-radius: 4px;
                ${maxSize(8, props.styleType, 'margin-top', 8)};
            `
        }
    }}
`;

export const ChoiceItemWrapper = styled('div')`
    ${props => {
            if(props.styleType === STYLE_TYPE.MOBILE) {
                return `border-top: 1px solid #B69A67;`
            } else {
                return `border-bottom: 1px solid #B69A67;`
            }  
        }
    }
    margin: auto;
    ${props => maxSize(68, props.styleType, 'height', 76)};
    display: flex;
    justify-content: center;
    align-items: center;
`;


export const ChoiceItemText = styled('div')`
    ${props => maxSize(24, props.styleType, 'margin-left', 24)};
    ${props => maxSize(24, props.styleType, 'margin-right', 24)};
    ${props => maxSize(223, props.styleType, 'max-width', 223)};
    ${props => maxSize(18, props.styleType, 'font-size', 18)};
    ${props => props.type === 'room' && maxSize(130, props.styleType, 'width', 116)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 0 0 auto;
    text-align: center;
`;
export const PlusButton = styled('div')`
    & img {
        width: 100%;
        height: 100%;
    }
    flex: 0 0 auto;
    ${props => maxSize(28, props.styleType, 'width', 28)};
    ${props => maxSize(28, props.styleType, 'height', 28)};
`;

export const MinusButton = styled('div')`
    & img {
        width: 100%;
        height: 100%;
    }
    flex: 0 0 auto;
    ${props => maxSize(28, props.styleType, 'width', 28)};
    ${props => maxSize(28, props.styleType, 'height', 28)};
`;


export const ButtonWrapper = styled('div')`
    display: flex;
    align-items: center;
    ${props => maxSize(372, props.styleType, 'width', 375)};
    ${props => maxSize(55, props.styleType, 'height', 56)};
    ${props => {
        if(props.styleType === STYLE_TYPE.MOBILE) {
            return ` 
                background: ${themeColor};
            `;
        }
    }}
`;

export const CloseButton = styled('div')`
    ${props => maxSize(372, props.styleType, 'width', 375)};
    ${props => maxSize(55, props.styleType, 'height', 53)};
    & img {
        display: inline-block;
        ${props => maxSize(372, props.styleType, 'margin-top', 20)};
        ${props => maxSize(55, props.styleType, 'margin-left', 334)};
        ${props => maxSize(372, props.styleType, 'width', 15)};
        ${props => maxSize(55, props.styleType, 'height', 15)};
    }
`;

export const ClearButton = styled('div')`
    ${props => maxSize(18, props.styleType, 'font-size', 18)};
    ${props => maxSize(242, props.styleType, 'margin-left', 242)};
    color: #D1BB8B;
`;


export const ConfirmButton = styled('div')`
    ${props => maxSize(18, props.styleType, 'font-size', 18)};
    ${props => maxSize(24, props.styleType, 'margin-left', 24)};
    color: black;
`;

export const ErrorNotice = styled('div')`
display: flex;
align-items: center;
${props => maxSize(14, props.styleType, 'font-size', 14)};
${props => maxSize(17, props.styleType, 'margin-top', 20)};
${props => maxSize(16, props.styleType, 'margin-bottom', 8)};
${props => maxSize(0, props.styleType, 'margin-left', 18)};

& #dot {
    flex: 0 0 auto;
    display: inline-block;
    border-radius: 50%;
    background-color: #BA5B5B;
    ${props => maxSize(8, props.styleType, 'width', 10)};
    ${props => maxSize(8, props.styleType, 'height', 10)};
    ${props => maxSize(8, props.styleType, 'margin-right', 8)};
}
& #text {
    color: #BA5B5B;
    flex: 0 0 auto;
    max-width: 90%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
}

`

export const WechatWindow = styled('div')`
${props => maxSize(210, props.styleType, 'width', 210)};
${props => maxSize(239, props.styleType, 'height', 239)};
& img {
    width: 100%;
    height: 100%;
}
`;